import {Component, EventEmitter, Input, Output} from '@angular/core';
import {
  faCalendarPlus,
  faEnvelope,
  faPenToSquare,
  faPerson,
  faRoad,
  faSchool,
  faSign
} from '@fortawesome/free-solid-svg-icons';
import {
  StudentTicketListViewAsmResponseDTO
} from "../../../models/student-ticket/list-view/StudentTicketListViewAsmResponseDTO";
import {getTicketStatusColor} from "../../../models/student-ticket/TicketStatusASMColorMapping";

@Component({
  selector: 'app-ticket-card-details',
  templateUrl: './ticket-card-details.component.html',
  styleUrls: ['./ticket-card-details.component.scss'],
  standalone: false,
})
export class TicketCardDetailsComponent {

  @Input() ticket: StudentTicketListViewAsmResponseDTO;
  @Input() addressDataChangeEnabled = false;
  @Input() schoolDataChangeEnabled = false;

  @Output() addressDetailsAdjust = new EventEmitter<void>();
  @Output() schoolDetailsAdjust = new EventEmitter<void>();
  @Output() nameDetailsAdjust = new EventEmitter<void>();
  @Output() emailDetailsAdjust = new EventEmitter<void>();

  faPerson = faPerson;
  faSign = faSign;
  faSchool = faSchool;
  faRoad = faRoad;
  faPenToSquare = faPenToSquare;
  faEnvelope = faEnvelope;

  protected readonly faCalendarPlus = faCalendarPlus;
  protected readonly getTicketStatusColor = getTicketStatusColor;

  adjustAdressDetails() {
    this.addressDetailsAdjust.emit();
  }

  adjustSchoolDetails() {
    this.schoolDetailsAdjust.emit();
  }

  adjustNameDetails() {
    this.nameDetailsAdjust.emit();
  }

  adjustEmailDetails() {
    this.emailDetailsAdjust.emit();
  }

}
